import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	fetchGroupLoanOfficerListFailure,
	fetchGroupLoanOfficerListResponseChanged,
	fetchGroupLoanOfficerListSuccess,
	getPromiseToPayReportExcelFailure,
	getPromiseToPayReportExcelResponseChanged,
	getPromiseToPayReportExcelSuccess,
	getPromiseToPayReportListFailure,
	getPromiseToPayReportListResponseChanged,
	getPromiseToPayReportListSuccess,
} from './promise-to-pay-report.action';
import PromiseToPayReportActionTypes from './promise-to-pay-report.type';
import {
	fetchGroupLOanOfficerList,
	promiseToPayReportExcelget,
	promiseToPayReportListGet,
} from './promise-to-pay-report.service';

/***************** GET PROMISE TO PAY REPORT START ************* */
export function* getPromiseToPayReport({ payload }: any) {
	try {
		const key = 'GetPromiseToPayReportListKey';
		const {
			databaseName,
			companyID,
			limit,
			requestStartDate,
			requestEndDate,
			branchID,
			centerID,
			groupID,
			officerName,
			DATETYPE,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			Limit: limit,
			FromDate: requestStartDate,
			ToDate: requestEndDate,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			OfficerID: officerName,
			DateType: DATETYPE,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(promiseToPayReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPromiseToPayReportListFailure(responseData.data));
		} else {
			yield put(getPromiseToPayReportListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPromiseToPayReportListFailure(error));
	}
}

export function* resetGetPromiseToPayReportListResponse() {
	yield put(getPromiseToPayReportListResponseChanged());
}

export function* onGetPromiseToPayReportListDetails() {
	yield takeLatest(
		PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_START,
		getPromiseToPayReport,
	);
}

export function* onGetPromiseToPayReportListResponseReset() {
	yield takeLatest(
		PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_RESPONSE_RESET,
		resetGetPromiseToPayReportListResponse,
	);
}
/***************** GET PROMISE TO PAY REPORT END ************* */

/******* START FETCH GROUP LOAN OFFICER LIST  ***********/
export function* groupLoanOfficerList({ payload }: any) {
	try {
		const key = 'GroupLoanOfficerListKey';
		const { branchID, centerID, groupID, companyID, databaseName } = payload;
		const jsonData = {
			AreaID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGroupLOanOfficerList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGroupLoanOfficerListFailure(responseData.data));
		} else {
			yield put(fetchGroupLoanOfficerListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGroupLoanOfficerListFailure(error));
	}
}

export function* resetFetchGroupLoanOfficerListResponse() {
	yield put(fetchGroupLoanOfficerListResponseChanged());
}

export function* onFetchGroupLoanOfficerList() {
	yield takeLatest(
		PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_START,
		groupLoanOfficerList,
	);
}

export function* onFetchGroupLoanOfficerListResponseReset() {
	yield takeLatest(
		PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_RESPONSE_RESET,
		resetFetchGroupLoanOfficerListResponse,
	);
}
/******* END FETCH GROUP LOAN OFFICER LIST  ***********/

/** ***************** GET PROMISE TO PAY REPORT EXCEL START *********************** */
export function* getPromiseToPayReposrtList({ payload }: any) {
	try {
		const key = 'GetPromiseToPayReportExcelListKey';
		const {
			branchID,
			centerID,
			groupID,
			officerName,
			requestStartDate,
			requestEndDate,
			DATETYPE,
			userID,
			requestID,
			generalCompanyID,
			companyID,
			databaseName,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			OfficerID: officerName,
			FromDate: requestStartDate,
			ToDate: requestEndDate,
			DateType: DATETYPE,
			UserID: userID,
			RequestID: requestID,
			GeneralCompanyID: generalCompanyID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(promiseToPayReportExcelget, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPromiseToPayReportExcelFailure(responseData.data));
		} else {
			yield put(getPromiseToPayReportExcelSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPromiseToPayReportExcelFailure(error));
	}
}

export function* resetGetPromiseToPayReportExcelListResponse() {
	yield put(getPromiseToPayReportExcelResponseChanged());
}

export function* onGetPromiseToPayReportExcelList() {
	yield takeLatest(
		PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_START,
		getPromiseToPayReposrtList,
	);
}

export function* onGetPromiseToPayReportExcelListResponseReset() {
	yield takeLatest(
		PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_RESPONSE_RESET_START,
		resetGetPromiseToPayReportExcelListResponse,
	);
}
/** ***************** GET PROMISE TO PAY REPORT EXCEL END *********************** */

export function* promiseToPayReportSaga() {
	yield all([
		call(onGetPromiseToPayReportListDetails),
		call(onGetPromiseToPayReportListResponseReset),
		call(onFetchGroupLoanOfficerList),
		call(onFetchGroupLoanOfficerListResponseReset),
		call(onGetPromiseToPayReportExcelList),
		call(onGetPromiseToPayReportExcelListResponseReset),
	]);
}
